import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import Icon from '../../../components/AppIcon';

const WeeklyTrendsChart = ({ weeklyData }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg shadow-lg p-3">
          <p className="text-sm font-medium text-foreground mb-2">{payload?.[0]?.payload?.day}</p>
          <div className="space-y-1">
            <p className="text-xs caption text-foreground">
              Calories: <span className="font-semibold data-text">{payload?.[0]?.value}</span>
            </p>
            <p className="text-xs caption text-foreground">
              Target: <span className="font-semibold data-text">{payload?.[0]?.payload?.target}</span>
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
          Weekly Trends
        </h3>
        <div className="flex items-center gap-2">
          <Icon name="TrendingUp" size={18} color="var(--color-success)" />
          <span className="text-sm caption text-success font-medium">
            +5% vs last week
          </span>
        </div>
      </div>

      <div className="w-full h-64 md:h-80" aria-label="Weekly Calorie Intake Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={weeklyData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="day" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
              iconType="circle"
            />
            <Bar 
              dataKey="calories" 
              fill="var(--color-primary)" 
              radius={[8, 8, 0, 0]}
              name="Calories Consumed"
            />
            <Bar 
              dataKey="target" 
              fill="var(--color-muted)" 
              radius={[8, 8, 0, 0]}
              name="Target Calories"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 pt-6 border-t border-border">
        <div className="text-center">
          <p className="text-xs md:text-sm caption text-muted-foreground mb-1">Avg Daily</p>
          <p className="text-lg md:text-xl font-heading font-bold data-text text-foreground">
            2,145
          </p>
          <p className="text-xs caption text-muted-foreground">kcal</p>
        </div>
        <div className="text-center">
          <p className="text-xs md:text-sm caption text-muted-foreground mb-1">Best Day</p>
          <p className="text-lg md:text-xl font-heading font-bold data-text text-success">
            2,050
          </p>
          <p className="text-xs caption text-muted-foreground">kcal</p>
        </div>
        <div className="text-center">
          <p className="text-xs md:text-sm caption text-muted-foreground mb-1">Consistency</p>
          <p className="text-lg md:text-xl font-heading font-bold data-text text-foreground">
            86%
          </p>
          <p className="text-xs caption text-muted-foreground">on target</p>
        </div>
        <div className="text-center">
          <p className="text-xs md:text-sm caption text-muted-foreground mb-1">Streak</p>
          <p className="text-lg md:text-xl font-heading font-bold data-text text-accent">
            5
          </p>
          <p className="text-xs caption text-muted-foreground">days</p>
        </div>
      </div>
    </div>
  );
};

export default WeeklyTrendsChart;